const NAFTA = new Set([
  'FARGO',
  'RACINE',
  'NEW HOLLAND',
  'GRAND ISLAND',
  'GRANDISLAND'
]);

const EMEA = new Set([
  'LECCE',
  'MODENA',
  'CROIX',
  'COEX',
  'ZEDELGEM'
]);

const DEFAULT_INTERNAL_HOURLY_TARIFF = 1;
const INTERNAL_HOURLY_TARIFFS = Object.freeze({
  LECCE: 29.84,
  MODENA: 30.25
});

//EMEA(LECCE, MODENA, CROIX, COEX,ZEDELGEM)Last completion
//NAFTA(FARGO, RACINE, NEW HOLLAND, GRAND ISLAND)start date

const plants = ['ZEDELGEM'];

function normalizePlantDesc(plantDesc) {
  return typeof plantDesc === 'string'
    ? plantDesc.trim().toUpperCase().replace(/\s+/g, ' ')
    : '';
}

function isNAFTA(plantDesc) {
  return NAFTA.has(normalizePlantDesc(plantDesc));
}

function getInternalHourlyTariff(plantDesc) {
  const normalizedPlant = normalizePlantDesc(plantDesc);
  return INTERNAL_HOURLY_TARIFFS[normalizedPlant] ?? DEFAULT_INTERNAL_HOURLY_TARIFF;
}

function isSupplierFeatureEnabled(plantDesc) {
  const normalized = normalizePlantDesc(plantDesc);
  return Boolean(normalized) && !NAFTA.has(normalized);
}

function isEMEA(plantDesc) {
  return EMEA.has(normalizePlantDesc(plantDesc));
}

function isPlantNewEwoFeatures(plantDesc) {
  return plants.includes(plantDesc);
}

function zedelgemCondition(user) {
  return (
    plants.includes(user.plantdesc) && [1, 4, 5, 8].includes(user.idprofilo)
  );
}

function croixCondition(user) {
  return user.plantdesc === 'CROIX';
}

function LecceCondition(user) {
  return user.plantdesc === 'LECCE';
}

function ModenaCondition(user) {
  return user.plantdesc === 'MODENA';
}
function ModenaBrekdowntype(value, user) {
  if (!ModenaCondition(user)) return value;
  const map = {
    '1 Partial': '1 Macchina Lavora',
    '2 Total': '2 Macchina Ferma'
  };
  return map[value] || value;
}

export {
  isPlantNewEwoFeatures,
  isNAFTA,
  isSupplierFeatureEnabled,
  zedelgemCondition,
  LecceCondition,
  ModenaCondition,
  ModenaBrekdowntype,
  croixCondition,
  getInternalHourlyTariff,
  DEFAULT_INTERNAL_HOURLY_TARIFF
};
